import { useEffect } from "react";
import { Reveal } from "@/lib/reveal";
import { useLanguage } from "@/context/LanguageContext";

export const Testimonials = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Check if script is already present; if not, inject it
    const scriptId = "sk-google-reviews-script";
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://widgets.sociablekit.com/google-reviews/widget.js";
      script.defer = true;
      document.body.appendChild(script);
    } else {
      // Re-initialize widget if already present in DOM
      if (window.sk_widget_mounts && typeof window.sk_widget_mounts[".sk-ww-google-reviews"] === "function") {
        window.sk_widget_mounts[".sk-ww-google-reviews"]();
      }
    }
  }, []);

  return (
    <section id="testimonials" data-testid="testimonials" className="py-24 md:py-32 bg-secondary/20 border-y border-border">
      <div className="container-x">
        {/* Section Header */}
        <div className="mb-10 md:mb-14 text-center max-w-2xl mx-auto">
          <Reveal className="overline font-bold tracking-[0.2em]">{t.testimonials.overline}</Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-foreground leading-[1.1]">
              {t.testimonials.title}
            </h2>
          </Reveal>
        </div>

        {/* Live SociableKIT Google Reviews Widget */}
        <div className="w-full min-h-[350px]">
          <div className="sk-ww-google-reviews" data-embed-id="25710835"></div>
        </div>
      </div>
    </section>
  );
};

